import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Locize from 'i18next-locize-backend';
import type { InitOptions } from 'i18next';

const i18nextOptions: InitOptions = {
  backend: {
    projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID || '2c0a136a-e84b-4380-bbdd-8c7e033c41a3',
    apiKey: process.env.REACT_APP_LOCIZE_API_KEY || '5e9e1de2-bf79-4fbd-a74e-05772a0a1d12',
    referenceLng: 'en-US',
    // Add these options to ensure proper loading
    loadPath: 'https://api.locize.app/{{projectId}}/{{version}}/{{lng}}/{{ns}}',
    addPath: 'https://api.locize.app/missing/{{projectId}}/{{version}}/{{lng}}/{{ns}}',
  },
  lng: 'en-US',
  fallbackLng: 'en-US',
  ns: [
    'admin',
    'accountSettings',
    'alarms2',
    'common',
    'energy',
    'homeIndex',
    'iso',
    'layout',
    'project',
    'reportsIndex',
    'repository',
    'task',
    'assetManagement',
    'iaq',
    'reports',
    'backlog',
    'partner',
    'digitalSignage',
    'waste'
  ],
  defaultNS: 'common',
  saveMissing: false,
  debug: true,

  initImmediate: false,

  load: 'currentOnly' as const, 

  preload: ['en-US', 'nb-NO'], 
  
  interpolation: {
    escapeValue: false,
  },
  
  react: {
    useSuspense: false, 
  }
};

i18next
  .use(Locize)
  .use(initReactI18next)
  .init(i18nextOptions, (error) => {
    if (error) {
      console.error('i18next initialization error:', error);
    } else {
      console.log('i18next initialized successfully');
    }
  });

export default i18next;